
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import Card from '../../components/base/Card';

export default function Products() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedBrand, setSelectedBrand] = useState('all');

  const categories = [
    { id: 'all', name: 'All Products', icon: 'ri-apps-line' },
    { id: 'washers', name: 'Washer Extractors', icon: 'ri-water-flash-line' },
    { id: 'dryers', name: 'Tumble Dryers', icon: 'ri-sun-line' },
    { id: 'ironers', name: 'Flat Work Ironers', icon: 'ri-iron-line' },
    { id: 'finishing', name: 'Finishing Equipment', icon: 'ri-brush-line' },
    { id: 'accessories', name: 'Accessories', icon: 'ri-tools-line' }
  ];

  const brands = [
    { id: 'all', name: 'All Brands' },
    { id: 'wonderclean', name: 'Wonder Clean India' },
    { id: 'electrolux', name: 'Electrolux Professional' },
    { id: 'stefab', name: 'Stefab India' },
    { id: 'alliance', name: 'Alliance Laundry Systems' }
  ];

  const products = [
    {
      id: 1,
      name: 'Professional Washer Extractor WE-35',
      brand: 'wonderclean',
      category: 'washers',
      capacity: '35 kg',
      features: ['High G-Force Extraction', 'Programmable Control', 'Stainless Steel Drum', 'Energy Efficient'],
      image: '/images/products/washer-extractor-35kg.jpg',
      description: 'Heavy-duty washer extractor designed for commercial laundry operations with superior extraction performance.'
    },
    {
      id: 2,
      name: 'Industrial Tumble Dryer TD-50',
      brand: 'electrolux',
      category: 'dryers',
      capacity: '50 kg',
      features: ['Gas/Electric Options', 'Moisture Sensing', 'Reversing Drum', 'Cool Down Cycle'],
      image: '/images/products/tumble-dryer-50kg.jpg',
      description: 'High-capacity tumble dryer with advanced moisture sensing technology for optimal drying results.'
    },
    {
      id: 3,
      name: 'Flat Work Ironer FWI-3200',
      brand: 'stefab',
      category: 'ironers',
      capacity: '3200 mm',
      features: ['Multi-Roll Design', 'Temperature Control', 'Variable Speed', 'Safety Systems'],
      image: '/images/products/flat-work-ironer.jpg',
      description: 'Professional flat work ironer for high-volume pressing of sheets, towels, and flat textiles.'
    },
    {
      id: 4,
      name: 'Commercial Washer WX-25',
      brand: 'alliance',
      category: 'washers',
      capacity: '25 kg',
      features: ['Side Loading', 'Programmable Controls', 'Water Recycling', 'Low Vibration'],
      image: '/images/products/washer-25kg.jpg',
      description: 'Efficient commercial washer with side-loading design for easy operation and maintenance.'
    },
    {
      id: 5,
      name: 'High Speed Dryer HSD-35',
      brand: 'wonderclean',
      category: 'dryers',
      capacity: '35 kg',
      features: ['Fast Drying', 'Energy Efficient', 'Lint Filter', 'Easy Maintenance'],
      image: '/images/products/high-speed-dryer-35kg.jpg',
      description: 'High-speed tumble dryer designed for rapid drying cycles and energy efficiency.'
    },
    {
      id: 6,
      name: 'Shirt Finishing Unit SFU-12',
      brand: 'electrolux',
      category: 'finishing',
      capacity: '12 shirts/hour',
      features: ['Automated Pressing', 'Steam System', 'Ergonomic Design', 'Quality Finish'],
      image: '/images/products/shirt-finishing-unit.jpg',
      description: 'Automated shirt finishing unit for professional garment pressing and finishing.'
    },
    {
      id: 7,
      name: 'Washer Extractor WE-75',
      brand: 'stefab',
      category: 'washers',
      capacity: '75 kg',
      features: ['Heavy Duty', 'High G-Force', 'Inverter Control', 'Water Saving'],
      image: '/images/products/washer-extractor-75kg.jpg',
      description: 'Heavy-duty washer extractor for high-volume commercial laundry operations.'
    },
    {
      id: 8,
      name: 'Steam Dryer SD-40',
      brand: 'alliance',
      category: 'dryers',
      capacity: '40 kg',
      features: ['Steam Heating', 'Precise Control', 'Gentle Drying', 'Low Energy'],
      image: '/images/products/steam-dryer-40kg.jpg',
      description: 'Steam-heated dryer offering gentle and efficient drying for delicate fabrics.'
    },
    {
      id: 9,
      name: 'Conveyor Ironer CI-2500',
      brand: 'wonderclean',
      category: 'ironers',
      capacity: '2500 mm',
      features: ['Continuous Operation', 'Heat Recovery', 'Adjustable Pressure', 'Quality Finish'],
      image: '/images/products/conveyor-ironer.jpg',
      description: 'Conveyor ironer for continuous processing of flat work with heat recovery system.'
    },
    {
      id: 10,
      name: 'Barrier Washer BW-60',
      brand: 'electrolux',
      category: 'washers',
      capacity: '60 kg',
      features: ['Hygiene Barrier', 'Dual Doors', 'Contamination Control', 'Hospital Grade'],
      image: '/images/products/barrier-washer-60kg.jpg',
      description: 'Barrier washer designed for healthcare facilities with contamination control features.'
    },
    {
      id: 11,
      name: 'Garment Conveyor GC-8M',
      brand: 'stefab',
      category: 'accessories',
      capacity: '8 meters',
      features: ['Variable Speed', 'Heavy Duty', 'Modular Design', 'Easy Installation'],
      image: '/images/products/garment-conveyor.jpg',
      description: 'Heavy-duty garment conveyor system for efficient workflow in commercial laundries.'
    },
    {
      id: 12,
      name: 'Folding Machine FM-120',
      brand: 'alliance',
      category: 'finishing',
      capacity: '120 pieces/hour',
      features: ['Automatic Folding', 'Size Detection', 'Stack Output', 'Easy Operation'],
      image: '/images/products/folding-machine.jpg',
      description: 'Automatic folding machine with size detection and stack output for efficient processing.'
    }
  ];

  const filteredProducts = products.filter(product => {
    const categoryMatch = selectedCategory === 'all' || product.category === selectedCategory;
    const brandMatch = selectedBrand === 'all' || product.brand === selectedBrand;
    return categoryMatch && brandMatch;
  });

  const specifications = [
    { label: 'Capacity Range', value: '15kg - 200kg', icon: 'ri-stack-line' },
    { label: 'Energy Efficiency', value: 'A++ Rated', icon: 'ri-leaf-line' },
    { label: 'Control System', value: 'Digital Programmable', icon: 'ri-cpu-line' },
    { label: 'Construction', value: 'Stainless Steel', icon: 'ri-shield-check-line' },
    { label: 'Warranty', value: '2-5 Years', icon: 'ri-award-line' },
    { label: 'Installation', value: 'Professional Setup', icon: 'ri-tools-line' }
  ];

  return (
    <div className="min-h-screen bg-white relative overflow-hidden">
      <Header />
      
      {/* Hero Section - Professional Glass-Effect Design */}
      <section className="pt-32 pb-20 bg-white relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0">
          <div 
            className="absolute inset-0 bg-cover bg-center opacity-5"
            style={{
              backgroundImage: `url('/images/backgrounds/products-hero-bg.jpg')`
            }}
          ></div>
        </div>

        {/* Floating Background Elements */}
        <div className="absolute top-20 left-20 w-32 h-32 bg-blue-200/30 rounded-full blur-2xl animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-40 h-40 bg-teal-200/30 rounded-full blur-2xl animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/3 w-24 h-24 bg-purple-200/30 rounded-full blur-xl animate-pulse delay-500"></div>
        <div className="absolute top-1/4 right-1/3 w-36 h-36 bg-cyan-200/30 rounded-full blur-2xl animate-pulse delay-1500"></div>

        {/* Floating 3D Icon Elements */}
        <div className="absolute top-40 left-1/3 w-12 h-12 bg-white/90 backdrop-blur-2xl border border-white/30 rounded-2xl flex items-center justify-center shadow-2xl animate-float">
          <i className="ri-water-flash-line text-blue-500 text-lg"></i>
        </div>
        <div className="absolute bottom-32 right-1/3 w-12 h-12 bg-white/90 backdrop-blur-2xl border border-white/30 rounded-2xl flex items-center justify-center shadow-2xl animate-float" style={{ animationDelay: '1.5s' }}>
          <i className="ri-iron-line text-teal-500 text-lg"></i>
        </div>
        <div className="absolute top-1/3 left-20 w-10 h-10 bg-white/80 backdrop-blur-xl border border-white/40 rounded-xl flex items-center justify-center shadow-xl animate-float" style={{ animationDelay: '0.8s' }}>
          <i className="ri-sun-line text-purple-500 text-sm"></i>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full relative z-10">
          <div className="text-center">
            <div className="mb-8">
              <span className="inline-flex items-center px-6 py-3 rounded-full bg-white/60 backdrop-blur-2xl border border-white/30 text-blue-800 text-sm font-semibold shadow-2xl">
                <div className="w-8 h-8 bg-blue-500/20 rounded-full flex items-center justify-center mr-3">
                  <i className="ri-settings-4-line text-sm text-blue-600"></i>
                </div>
                Premium Commercial Equipment
                <span className="w-2 h-2 bg-blue-500 rounded-full ml-3 animate-pulse"></span>
              </span>
            </div>

            <h1 className="text-5xl md:text-6xl font-bold mb-8 text-gray-900 leading-tight">
              Professional Laundry{' '}
              <span className="text-blue-600">
                Solutions
              </span>
            </h1>

            <p className="text-xl md:text-2xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
              Discover our comprehensive range of world-class commercial laundry equipment 
              from renowned manufacturers with complete service support
            </p>
          </div>
        </div>

        {/* Custom CSS for floating animation */}
        <style jsx>{`
          @keyframes animate-float {
            0%, 100% {
              transform: translateY(0px) rotate(0deg);
            }
            50% {
              transform: translateY(-10px) rotate(5deg);
            }
          }
          .animate-float {
            animation: animate-float 3s ease-in-out infinite;
          }
        `}</style>
      </section>

      {/* Specifications Section - Enhanced Glass Design */}
      <section className="py-12 bg-white/50 backdrop-blur-sm shadow-2xl border-y border-white/30 relative overflow-hidden">
        {/* Background Effects */}
        <div className="absolute inset-0">
          <div className="absolute top-10 left-10 w-24 h-24 bg-blue-200/20 rounded-full blur-2xl animate-pulse"></div>
          <div className="absolute bottom-10 right-10 w-20 h-20 bg-teal-200/25 rounded-full blur-xl animate-pulse delay-1000"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-12">
            <div className="inline-flex items-center px-6 py-3 rounded-full bg-white/60 backdrop-blur-2xl border border-white/30 text-blue-800 text-sm font-semibold shadow-2xl mb-6">
              <div className="w-8 h-8 bg-blue-500/20 rounded-full flex items-center justify-center mr-3">
                <i className="ri-bar-chart-line text-blue-600 text-sm"></i>
              </div>
              Technical Specifications
              <div className="w-2 h-2 bg-blue-500 rounded-full ml-3 animate-pulse"></div>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Equipment Standards
            </h2>
            <p className="text-lg text-gray-700 max-w-2xl mx-auto leading-relaxed">
              Industry-leading specifications across our complete product range
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6">
            {specifications.map((spec, index) => (
              <div key={index} className="group cursor-pointer">
                <div className="bg-white/40 backdrop-blur-2xl rounded-3xl p-6 shadow-2xl hover:shadow-3xl transition-all duration-500 group-hover:-translate-y-3 group-hover:scale-105 border border-white/30 relative overflow-hidden h-full">
                  {/* Glass Background Layers */}
                  <div className="absolute inset-0 bg-white/20 backdrop-blur-xl rounded-3xl"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-white/30 via-white/10 to-white/5 rounded-3xl"></div>
                  
                  {/* Floating Particles */}
                  <div className="absolute top-2 right-2 w-1 h-1 bg-blue-400/60 rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-ping transition-all duration-500"></div>
                  <div className="absolute bottom-3 left-3 w-1.5 h-1.5 bg-teal-400/50 rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-pulse transition-all duration-700" style={{ animationDelay: '0.3s' }}></div>

                  <div className="relative z-10 text-center">
                    {/* 3D Icon Container */}
                    <div className="relative mb-4">
                      <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-3xl flex items-center justify-center mx-auto shadow-2xl group-hover:shadow-3xl group-hover:scale-110 transition-all duration-500 border border-white/30 relative">
                        {/* 3D Shadow Effect */}
                        <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-blue-700 rounded-3xl transform translate-x-1 translate-y-1 -z-10 group-hover:translate-x-2 group-hover:translate-y-2 transition-transform duration-500"></div>
                        <i className={`${spec.icon} text-white text-2xl group-hover:scale-110 transition-transform duration-300`}></i>

                        {/* Icon Glow Effect */}
                        <div className="absolute inset-0 bg-gradient-to-br from-blue-400/50 to-blue-400/30 rounded-3xl opacity-0 group-hover:opacity-100 group-hover:scale-125 blur-xl transition-all duration-500"></div>
                      </div>

                      {/* Floating Ring */}
                      <div className="absolute inset-0 w-16 h-16 mx-auto border-2 border-blue-300/30 rounded-3xl group-hover:scale-150 group-hover:border-blue-400/20 transition-all duration-700 opacity-0 group-hover:opacity-100"></div>
                    </div>

                    {/* Content Container */}
                    <div className="relative bg-white/20 backdrop-blur-sm rounded-2xl p-4 border border-white/30 group-hover:bg-white/30 transition-all duration-500">
                      <div className="text-sm text-blue-600 font-medium mb-2 group-hover:text-blue-700 transition-colors duration-300">{spec.label}</div>
                      <div className="font-bold text-gray-800 text-lg group-hover:text-gray-900 transition-colors duration-300">{spec.value}</div>

                      {/* Interactive Progress Bar */}
                      <div className="mt-4 h-1 bg-white/30 rounded-full overflow-hidden">
                        <div className="h-full bg-blue-500 rounded-full transform -translate-x-full group-hover:translate-x-0 transition-transform duration-1000 shadow-lg"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Products Grid with Integrated Filters - Enhanced Glass Design */}
      <section className="py-20 bg-gradient-to-br from-gray-50 via-white to-blue-50 relative overflow-hidden" data-product-shop>
        {/* Background Effects */}
        <div className="absolute inset-0">
          <div className="absolute top-20 left-20 w-40 h-40 bg-blue-200/20 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-20 right-20 w-32 h-32 bg-teal-200/25 rounded-full blur-2xl animate-pulse delay-1000"></div>
          <div className="absolute top-1/2 left-1/4 w-28 h-28 bg-purple-200/20 rounded-full blur-2xl animate-pulse delay-500"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-12">
            <div className="inline-flex items-center px-6 py-3 rounded-full bg-white/60 backdrop-blur-2xl border border-white/30 text-blue-800 text-sm font-semibold shadow-2xl mb-6">
              <div className="w-8 h-8 bg-blue-500/20 rounded-full flex items-center justify-center mr-3">
                <i className="ri-shopping-bag-3-line text-blue-600 text-sm"></i>
              </div>
              Featured Products
              <div className="w-2 h-2 bg-blue-500 rounded-full ml-3 animate-pulse"></div>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Find Your Perfect Equipment
            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed mb-12">
              Filter by category and brand to discover the ideal solution for your needs
            </p>

            {/* Integrated Filters */}
            <div className="bg-white/40 backdrop-blur-2xl rounded-3xl p-8 shadow-2xl border border-white/30 relative overflow-hidden mb-16">
              {/* Glass Background Layers */}
              <div className="absolute inset-0 bg-white/20 backdrop-blur-xl rounded-3xl"></div>
              <div className="absolute inset-0 bg-gradient-to-br from-white/30 via-white/10 to-white/5 rounded-3xl"></div>
              
              <div className="relative z-10">
                <div className="flex flex-col lg:flex-row gap-8">
                  {/* Category Filter */}
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                      <div className="w-6 h-6 bg-blue-500/20 rounded-lg flex items-center justify-center mr-3">
                        <i className="ri-apps-line text-blue-600 text-sm"></i>
                      </div>
                      Product Categories
                    </h3>
                    <div className="flex flex-wrap gap-3">
                      {categories.map((category) => (
                        <button
                          key={category.id}
                          onClick={() => setSelectedCategory(category.id)}
                          className={`group relative flex items-center px-6 py-3 rounded-2xl text-sm font-medium transition-all duration-500 shadow-lg hover:shadow-xl ${
                            selectedCategory === category.id
                              ? 'bg-blue-600/90 backdrop-blur-2xl text-white border border-white/30'
                              : 'bg-white/50 backdrop-blur-xl text-gray-700 hover:bg-white/70 border border-white/40'
                          }`}
                        >
                          {selectedCategory === category.id && (
                            <div className="absolute inset-0 bg-blue-700/80 backdrop-blur-xl rounded-2xl transform translate-x-1 translate-y-1 -z-10 shadow-2xl"></div>
                          )}
                          <div className={`w-6 h-6 rounded-lg flex items-center justify-center mr-3 transition-all duration-300 ${
                            selectedCategory === category.id 
                              ? 'bg-white/20 group-hover:scale-110' 
                              : 'bg-blue-500/20 group-hover:scale-110'
                          }`}>
                            <i className={`${category.icon} text-sm ${
                              selectedCategory === category.id ? 'text-white' : 'text-blue-600'
                            }`}></i>
                          </div>
                          {category.name}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Brand Filter */}
                  <div className="lg:w-80">
                    <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                      <div className="w-6 h-6 bg-teal-500/20 rounded-lg flex items-center justify-center mr-3">
                        <i className="ri-building-line text-teal-600 text-sm"></i>
                      </div>
                      Brand Selection
                    </h3>
                    <div className="flex flex-wrap gap-3">
                      {brands.map((brand) => (
                        <button
                          key={brand.id}
                          onClick={() => setSelectedBrand(brand.id)}
                          className={`group relative px-5 py-3 rounded-2xl text-sm font-medium transition-all duration-500 shadow-lg hover:shadow-xl ${
                            selectedBrand === brand.id
                              ? 'bg-teal-600/90 backdrop-blur-2xl text-white border border-white/30'
                              : 'bg-white/50 backdrop-blur-xl text-gray-700 hover:bg-white/70 border border-white/40'
                          }`}
                        >
                          {selectedBrand === brand.id && (
                            <div className="absolute inset-0 bg-teal-700/80 backdrop-blur-xl rounded-2xl transform translate-x-1 translate-y-1 -z-10 shadow-2xl"></div>
                          )}
                          {brand.name}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="mt-8 flex items-center justify-between">
                  <div className="bg-white/30 backdrop-blur-xl rounded-2xl px-6 py-3 border border-white/40 shadow-lg">
                    <p className="text-gray-700 font-medium">
                      Showing <span className="text-blue-600 font-bold">{filteredProducts.length}</span> of <span className="font-bold">{products.length}</span> products
                    </p>
                  </div>
                  <Link to="/contact">
                    <div className="group/btn relative">
                      <div className="absolute inset-0 bg-blue-700/80 backdrop-blur-2xl rounded-2xl transform translate-x-2 translate-y-2 group-hover/btn:translate-x-3 group-hover/btn:translate-y-3 transition-transform duration-500 shadow-2xl"></div>
                      <button className="relative bg-blue-600/90 backdrop-blur-2xl hover:bg-blue-700/90 text-white font-bold px-6 py-3 rounded-2xl transition-all duration-500 transform hover:-translate-y-1 hover:scale-105 shadow-2xl hover:shadow-3xl whitespace-nowrap border border-white/20">
                        <span className="flex items-center">
                          <div className="w-5 h-5 bg-white/20 backdrop-blur-xl rounded-lg flex items-center justify-center mr-2 group-hover/btn:scale-110 transition-transform duration-300">
                            <i className="ri-phone-line text-xs"></i>
                          </div>
                          Get Quote
                        </span>
                      </button>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {filteredProducts.map((product) => (
              <div key={product.id} className="group cursor-pointer">
                <div className="bg-white/40 backdrop-blur-2xl rounded-3xl shadow-2xl hover:shadow-3xl transition-all duration-500 group-hover:-translate-y-3 group-hover:scale-105 border border-white/30 relative overflow-hidden h-full">
                  {/* Glass Background Layers */}
                  <div className="absolute inset-0 bg-white/20 backdrop-blur-xl rounded-3xl"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-white/30 via-white/10 to-white/5 rounded-3xl"></div>
                  
                  {/* Floating Particles */}
                  <div className="absolute top-4 right-4 w-1 h-1 bg-blue-400/60 rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-ping transition-all duration-500"></div>
                  <div className="absolute bottom-6 left-6 w-1.5 h-1.5 bg-teal-400/50 rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-pulse transition-all duration-700" style={{ animationDelay: '0.3s' }}></div>

                  <div className="relative z-10 h-full flex flex-col">
                    {/* Image Container */}
                    <div className="aspect-square relative overflow-hidden rounded-t-3xl">
                      <img 
                        src={product.image}
                        alt={product.name}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                      
                      {/* Capacity Badge */}
                      <div className="absolute top-4 left-4">
                        <div className="bg-white/90 backdrop-blur-2xl border border-white/40 text-blue-600 px-3 py-2 rounded-2xl text-sm font-bold shadow-2xl">
                          <i className="ri-stack-line mr-1"></i>
                          {product.capacity}
                        </div>
                      </div>
                      
                      {/* Brand Badge */}
                      <div className="absolute top-4 right-4">
                        <div className="bg-white/90 backdrop-blur-2xl border border-white/40 text-gray-800 px-3 py-2 rounded-2xl text-xs font-medium shadow-2xl">
                          {brands.find(b => b.id === product.brand)?.name}
                        </div>
                      </div>

                      {/* Hover Overlay - Removed blur effect */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500 rounded-t-3xl"></div>
                    </div>

                    {/* Content Container */}
                    <div className="p-6 flex-1 flex flex-col">
                      <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-6 border border-white/30 group-hover:bg-white/30 transition-all duration-500 h-full flex flex-col">
                        <h3 className="text-lg font-bold text-gray-900 mb-3 line-clamp-2 group-hover:text-blue-700 transition-colors duration-300">
                          {product.name}
                        </h3>
                        
                        <p className="text-gray-700 text-sm mb-4 flex-1 group-hover:text-gray-800 transition-colors duration-300">
                          {product.description}
                        </p>
                        
                        {/* Features */}
                        <div className="space-y-4">
                          <div className="flex flex-wrap gap-2">
                            {product.features.slice(0, 3).map((feature, index) => (
                              <span key={index} className="bg-white/50 backdrop-xl text-gray-700 px-3 py-1 rounded-xl text-xs border border-white/40 shadow-lg group-hover:bg-white/70 transition-all duration-300">
                                {feature}
                              </span>
                            ))}
                          </div>
                          
                          {/* Price and CTA */}
                          <div className="flex items-center justify-center pt-4 border-t border-white/20">
                            <Link to={`/products/${product.id}`}>
                              <div className="group/btn relative">
                                <div className="absolute inset-0 bg-blue-700/80 backdrop-blur-xl rounded-xl transform translate-x-1 translate-y-1 group-hover:translate-x-2 group-hover:translate-y-2 transition-transform duration-500 shadow-xl"></div>
                                <button className="relative bg-blue-600/90 backdrop-blur-2xl hover:bg-blue-700/90 text-white font-bold px-4 py-2 rounded-xl transition-all duration-500 transform hover:-translate-y-1 hover:scale-105 shadow-xl hover:shadow-2xl whitespace-nowrap border border-white/20 text-sm">
                                  <span className="flex items-center">
                                    <div className="w-4 h-4 bg-white/20 backdrop-blur-xl rounded flex items-center justify-center mr-2 group-hover/btn:scale-110 transition-transform duration-300">
                                      <i className="ri-eye-line text-xs"></i>
                                    </div>
                                    Learn More
                                  </span>
                                </button>
                              </div>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Hover Arrow Indicator */}
                    <div className="absolute bottom-4 right-4 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 group-hover:scale-110 transition-all duration-500 border border-white/40">
                      <i className="ri-arrow-up-right-line text-blue-600 text-lg group-hover:scale-110 transition-transform duration-300"></i>
                    </div>
                  </div>

                  {/* Subtle Shine Effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-3xl"></div>
                </div>
              </div>
            ))}
          </div>

          {filteredProducts.length === 0 && (
            <div className="text-center py-20">
              <div className="bg-white/40 backdrop-blur-2xl rounded-3xl p-12 shadow-2xl border border-white/30 max-w-md mx-auto">
                <div className="w-20 h-20 bg-gray-200/50 backdrop-blur-xl rounded-3xl flex items-center justify-center mx-auto mb-6 shadow-xl">
                  <i className="ri-search-line text-4xl text-gray-400"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4">No Products Found</h3>
                <p className="text-gray-600 leading-relaxed">Try adjusting your filters to discover more equipment options</p>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Features Section - Professional Glass Design */}
      <section className="py-20 bg-white/50 backdrop-blur-sm relative overflow-hidden">
        {/* Background Effects */}
        <div className="absolute inset-0">
          <div className="absolute top-20 left-20 w-32 h-32 bg-blue-200/20 rounded-full blur-2xl animate-pulse"></div>
          <div className="absolute bottom-20 right-20 w-28 h-28 bg-teal-200/25 rounded-full blur-xl animate-pulse delay-1000"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <div className="inline-flex items-center px-6 py-3 rounded-full bg-white/60 backdrop-blur-2xl border border-white/30 text-blue-800 text-sm font-semibold shadow-2xl mb-6">
              <div className="w-8 h-8 bg-blue-500/20 rounded-full flex items-center justify-center mr-3">
                <i className="ri-star-line text-blue-600 text-sm"></i>
              </div>
              Why Choose Us
              <div className="w-2 h-2 bg-blue-500 rounded-full ml-3 animate-pulse"></div>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Premium Quality Promise</h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">Excellence in equipment, service, and support that sets us apart</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-award-line',
                title: 'Premium Quality',
                description: 'All equipment sourced from certified manufacturers with international quality standards and rigorous testing protocols',
                color: 'from-blue-500 to-blue-600'
              },
              {
                icon: 'ri-tools-line',
                title: 'Complete Support',
                description: 'Professional installation, comprehensive training, and nationwide after-sales service with rapid response times',
                color: 'from-teal-500 to-teal-600'
              },
              {
                icon: 'ri-shield-check-line',
                title: 'Extended Warranty',
                description: 'Comprehensive warranty coverage with prompt service response and genuine spare parts availability',
                color: 'from-purple-500 to-purple-600'
              }
            ].map((feature, index) => (
              <div key={index} className="group cursor-pointer">
                <div className="bg-white/40 backdrop-blur-2xl rounded-3xl p-8 shadow-2xl hover:shadow-3xl transition-all duration-500 group-hover:-translate-y-3 group-hover:scale-105 border border-white/30 relative overflow-hidden h-full">
                  {/* Glass Background Layers */}
                  <div className="absolute inset-0 bg-white/20 backdrop-blur-xl rounded-3xl"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-white/30 via-white/10 to-white/5 rounded-3xl"></div>
                  
                  {/* Floating Particles */}
                  <div className="absolute top-4 right-4 w-1 h-1 bg-blue-400/60 rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-ping transition-all duration-500"></div>
                  <div className="absolute bottom-6 left-4 w-1.5 h-1.5 bg-teal-400/50 rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-pulse transition-all duration-700" style={{ animationDelay: '0.3s' }}></div>

                  <div className="relative z-10 text-center">
                    {/* 3D Icon Container */}
                    <div className="relative mb-6">
                      <div className={`w-20 h-20 bg-gradient-to-br ${feature.color} rounded-3xl flex items-center justify-center mx-auto shadow-2xl group-hover:shadow-3xl group-hover:scale-110 transition-all duration-500 border border-white/30 relative`}>
                        {/* 3D Shadow Effect */}
                        <div className={`absolute inset-0 bg-gradient-to-br ${feature.color.replace('500', '600').replace('600', '700')} rounded-3xl transform translate-x-2 translate-y-2 -z-10 group-hover:translate-x-3 group-hover:translate-y-3 transition-transform duration-500`}></div>
                        <i className={`${feature.icon} text-white text-3xl group-hover:scale-110 transition-transform duration-300`}></i>

                        {/* Icon Glow Effect */}
                        <div className={`${feature.color.replace('500', '400').replace('600', '400')}/50 absolute inset-0 bg-gradient-to-br rounded-3xl opacity-0 group-hover:opacity-100 group-hover:scale-125 blur-xl transition-all duration-500`}></div>
                      </div>

                      {/* Floating Ring */}
                      <div className="absolute inset-0 w-20 h-20 mx-auto border-2 border-blue-300/30 rounded-3xl group-hover:scale-150 group-hover:border-blue-400/20 transition-all duration-700 opacity-0 group-hover:opacity-100"></div>
                    </div>

                    {/* Content Container */}
                    <div className="relative bg-white/20 backdrop-blur-sm rounded-2xl p-6 border border-white/30 group-hover:bg-white/30 transition-all duration-500">
                      <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-gray-800 transition-colors duration-300">
                        {feature.title}
                      </h3>
                      
                      <div className="w-12 h-1 bg-blue-500 rounded-full mx-auto mb-6 group-hover:w-20 transition-all duration-500 shadow-lg"></div>
                      
                      <p className="text-gray-700 leading-relaxed group-hover:text-gray-800 transition-colors duration-300">
                        {feature.description}
                      </p>

                      {/* Interactive Progress Bar */}
                      <div className="mt-6 h-2 bg-white/30 rounded-full overflow-hidden">
                        <div className="h-full bg-blue-500 rounded-full transform -translate-x-full group-hover:translate-x-0 transition-transform duration-1000 shadow-lg"></div>
                      </div>
                    </div>

                    {/* Hover Arrow Indicator */}
                    <div className="absolute bottom-4 right-4 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 group-hover:scale-110 transition-all duration-500 border border-white/40">
                      <i className="ri-arrow-up-right-line text-blue-600 text-lg group-hover:scale-110 transition-transform duration-300"></i>
                    </div>
                  </div>

                  {/* Subtle Shine Effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-3xl"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section - Enhanced Glass Design */}
      <section className="py-20 bg-gradient-to-r from-blue-600/90 to-teal-600/90 backdrop-blur-2xl relative overflow-hidden">
        {/* Background Effects */}
        <div className="absolute inset-0 bg-gradient-to-r from-blue-700/20 to-teal-700/20"></div>
        <div className="absolute top-0 left-1/4 w-32 h-32 bg-white/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-1/4 w-40 h-40 bg-white/5 rounded-full blur-3xl animate-pulse delay-1000"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white relative z-10">
          <div className="mb-8">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">Need Help Choosing Equipment?</h2>
            <p className="text-xl mb-8 max-w-4xl mx-auto leading-relaxed text-blue-100">
              Our technical experts are ready to help you find the perfect laundry solution 
              tailored to your specific business requirements and operational needs
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <Link to="/contact">
              <div className="group/btn relative">
                <div className="absolute inset-0 bg-white/30 backdrop-blur-xl rounded-2xl transform translate-x-2 translate-y-2 group-hover/btn:translate-x-3 group-hover/btn:translate-y-3 transition-transform duration-500 shadow-2xl"></div>
                <button className="relative bg-white/20 backdrop-blur-2xl hover:bg-white/30 text-white font-bold px-8 py-4 rounded-2xl transition-all duration-500 transform hover:-translate-y-1 hover:scale-105 shadow-2xl hover:shadow-3xl whitespace-nowrap border border-white/30">
                  <span className="flex items-center">
                    <div className="w-6 h-6 bg-white/20 backdrop-blur-xl rounded-lg flex items-center justify-center mr-3 group-hover/btn:scale-110 transition-transform duration-300">
                      <i className="ri-phone-line text-sm"></i>
                    </div>
                    Get Expert Consultation
                  </span>
                </button>
              </div>
            </Link>
            <Link to="/services">
              <div className="group/btn relative">
                <div className="absolute inset-0 bg-white/30 backdrop-blur-xl rounded-2xl transform translate-x-2 translate-y-2 group-hover:translate-x-3 group-hover:translate-y-3 transition-transform duration-500 shadow-2xl"></div>
                <button className="relative bg-white/20 backdrop-blur-2xl hover:bg-white/30 text-white font-bold px-8 py-4 rounded-2xl transition-all duration-500 transform hover:-translate-y-1 hover:scale-105 shadow-2xl hover:shadow-3xl whitespace-nowrap border border-white/30">
                  <span className="flex items-center">
                    <div className="w-6 h-6 bg-white/20 backdrop-blur-xl rounded-lg flex items-center justify-center mr-3 group-hover:scale-110 transition-transform duration-300">
                      <i className="ri-service-line text-sm"></i>
                    </div>
                    View Services
                  </span>
                </button>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
